import { AnimationPlayer } from '@/_components';

function SubPagePreLoader() {
  return (
    <div className="flex h-screen w-full items-center justify-center">
      <AnimationPlayer />
    </div>
  );
}

export default SubPagePreLoader;
